import * as React from 'react';
import { connect } from "react-redux";
import { getQueryParam } from "../../utils/HelperFunctions";
import axios from 'axios';
import { ROOT_URL, SP_HOST_URL } from '../../actions/constants';
import { CALENDAR_MAX, CALENDAR_MIN } from "../../utils/DateUtils";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import * as moment from "moment";
import { ScheduleElement } from '../../models/ScheduleElement';
import StyleUtils from '../../utils/StyleUtils';
import * as _ from "lodash";
import { getScheduleElements } from '../../actions/Action_ScheduleElement';
import { getUkeplanElementsStudent } from '../../actions/Action_Ukeplan';
import { Checkbox, PrimaryButton, Spinner, SpinnerSize } from 'office-ui-fabric-react';
import UkeplanPrintStudent from './UkeplanPrintStudent';
import { ClassAssignmentGroup } from '../../models/ClassAssignmentGroup';
moment.locale("nb");

export interface IUkeplanPrintViewProps {
    scheduleElements: any;
    ukeplanelementsstudent:any;
    getScheduleElements(schoolClass: string, week: number, year: number, tilretteleggingsgruppeId?: number);
    getUkeplanElementsStudent(statedata: any,week: number,year: number);
  }

  export interface IUkeplanPrintViewState {
    isLoading:boolean;
    week: string;
    year: string;
    classId: string;
    studentId: string;
    studentName: string;
    selectedDate:any;
    students:any[];
    mode:string;
    printFor:string;
    assignmentGroups: ClassAssignmentGroup[];
    includeSchedule:boolean;
  }



  class UkeplanPrintView extends React.Component<
    IUkeplanPrintViewProps,
    IUkeplanPrintViewState
  > {
    constructor(props) {
        super(props);

        // this.state = {

        // }
      }

    getUkeplanElementsClass(classId: string, week: number, year: number) {
        axios.get(`${ROOT_URL}/GetUkeplanForClass?classId=${classId}&week=${week}&year=${year}`, {
            headers: {
                Authorization: localStorage.getItem('id_token'),
            },
        }).then((response) => {
            let students = response.data as any;

            let studentsWithGroup = students.map(student => {
              let assignmentGroup = this.state.assignmentGroups ? this.state.assignmentGroups.find(ag => ag.Students.findIndex(s => s.LoginName == student.LoginName) > -1) : null;

              student.AssignmentGroup = assignmentGroup;
              return student;
            });
            console.log("studentsWithGroup:", studentsWithGroup)
            console.log("response:", response.data)

            this.setState({students: studentsWithGroup});
            //this.setState({students: response.data});
        });
    }

    getClassAssignmentGroups = async (classId: string): Promise<ClassAssignmentGroup[]> => {
		const request = await axios.get(`${ROOT_URL}/GetClassAssignmentGroups/${classId}${SP_HOST_URL}`,{
			headers: {
				Authorization: localStorage.getItem('id_token')
			}
		});

		return request.data as ClassAssignmentGroup[];
	}

    mergeObjectsByPropertyWithReduce(arr: any[], property: string): any[] {
        const mergedObjects = arr.reduce((acc, item) => {
          const key = item[property];
          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            acc[key] = { ...acc[key], ...item };
          }
          return acc;
        }, {} as { [key: string]: any });
      
        return Object.values(mergedObjects);
      }

    mergeCoursesByPropertyWithReduce(arr: any[], property: string): any[] {
        const mergedObjects = arr.reduce((acc, item) => {
          const key = item[property];
          if (!acc[key]) {
            acc[key] = { ...item };
          } else {
            // Merge News, StudentTasks, StudentTexts
            const n = acc[key].News && item.News ? [...acc[key].News,...item.News] : item.News ? item.News : acc[key].News ? acc[key].News : [];
            const ta = [...acc[key].StudentTasks, ...item.StudentTasks];
            const te = [...acc[key].StudentTexts, ...item.StudentTexts];
            acc[key] = { ...acc[key], News:this.mergeObjectsByPropertyWithReduce(n,"Id"), StudentTasks:this.mergeObjectsByPropertyWithReduce(ta,"WsTaskId"), StudentTexts:this.mergeObjectsByPropertyWithReduce(te,"Id") };
            //acc[key] = { ...acc[key], ...item};
          }
          return acc;
        }, {} as { [key: string]: any});
      
        return Object.values(mergedObjects);
      }

    getStudentArray() {
        if (this.state) {
            if (this.state.mode === "STUDENT" && this.props.ukeplanelementsstudent) {
                let assignmentGroup = this.state.assignmentGroups ? this.state.assignmentGroups.find(ag => ag.Students.findIndex(s => s.LoginName == this.state.studentId) > -1) : null;

                return [{LoginName:this.state.studentId,Name:this.state.studentName,Courses:[...this.props.ukeplanelementsstudent.All], AssignmentGroup: assignmentGroup}];
            }
            if (this.state.mode === "CLASS" && this.state.students.length > 0) {
                if (!this.state.printFor) return this.state.students;
                else {
                    // Teacher print, reduce all stundents into a class view
                    const courses = [];
                    this.state.students.forEach((s)=>{
                        s.Courses.forEach((c)=>{
                            courses.push(c);
                        })
                    })
                    const coursesMerged = this.mergeCoursesByPropertyWithReduce(courses, "CourseID")
                    const tmp = [{LoginName:this.state.classId,Name:"Lærerutskrift",Courses:coursesMerged}];
                    return tmp;
                }
            }
        }
        return [];
    }

    async componentDidMount() {
      // Get queryparams
      const week = getQueryParam("week");
      const year = getQueryParam("year");
      const classId = getQueryParam("classid");
      const studentId = getQueryParam("studentid");
      const studentName = getQueryParam("studentname");
      const printFor = getQueryParam("printFor");
      const includeSchedule = true;

      let assignmentGroups = [];
      assignmentGroups = await this.getClassAssignmentGroups(classId);
      this.setState({assignmentGroups: assignmentGroups});

      this.props.getScheduleElements(classId,Number(week),Number(year));
      if (studentId) {
        this.props.getUkeplanElementsStudent({LoginName:studentId},Number(week),Number(year));
      }
      else {
        // assignmentGroups = await this.getClassAssignmentGroups(classId);
        // this.setState({assignmentGroups: assignmentGroups});
        this.getUkeplanElementsClass(classId,Number(week),Number(year));
      }
      
      this.setState(
        {
          week:week,
          year:year,
          classId:classId,
          studentId:studentId,
          studentName:studentName,
          selectedDate: moment().utc().isoWeekYear(Number(year)).isoWeek(Number(week)).isoWeekday(1).toDate(),
          students:[],
          mode: studentId ? "STUDENT" : "CLASS",
          printFor: printFor,
          assignmentGroups: assignmentGroups,
          includeSchedule: includeSchedule
        });
    }

    filterEvents() {
        // Returns an empty array if there are ScheduleElements yet
        if (_.isEmpty(this.props.scheduleElements)) {
          return [];
        }
    
        let values = _.values(this.props.scheduleElements).sort((a, b) => {
          if(a.Title < b.Title) { return -1; }
          if(a.Title > b.Title) { return 1; }
          return 0;
        });
    
        return values;
      }

    renderCustomEvent = (scheduleElement: ScheduleElement) => {
        return (
            <div className="custom-event-container">
                <div className="custom-event-label-print">
                    <span className="custom-event-label-time">
                    {scheduleElement.Start ? moment(scheduleElement.Start).format("HH:mm") : ""} - {scheduleElement.End ? moment(scheduleElement.End).format("HH:mm") : ""}
                    </span>
                </div>
                <div style={{color: 'black', wordWrap: "break-word", wordBreak: "break-word"}}>{scheduleElement.Title}</div>
            </div>
        )
      }
    
     eventStyleGetter(se: ScheduleElement) {
        return { style: new StyleUtils().getCalendarScheduleStylePrint() };
      }

    render() {
        const localizer = momentLocalizer(moment);
        const studentsArray = this.getStudentArray();
        return (!!this.state && this.props.scheduleElements && studentsArray.length>0) ? (
            <div style={{backgroundColor:"#ffffff", padding:"10px"}}>
                <div id="printOutput">
                    <div className="printButton">
                      <div  style={{marginTop:"10px", marginBottom:"10px", display: "flex", alignItems: "center"}}>
                            <PrimaryButton iconProps={{iconName:"Print"}} text='Skriv ut' onClick={()=>window.print()}/>
                            <Checkbox
                              label={`Inkluder timeplan`}
                              checked={this.state.includeSchedule}
                              onChange={(ev, checked) => this.setState({includeSchedule: checked})}
                            />
                      </div>
                    </div>
                    {studentsArray.map((student) => {
                        return (
                            <UkeplanPrintStudent
                                scheduleElements={this.props.scheduleElements}
                                student={student}
                                ukeplanelementsstudent={student.Courses}
                                selectedDate={this.state.selectedDate}
                                week={this.state.week}
                                year={this.state.year}
                                includeSchedule={this.state.includeSchedule}
                            />
                        )
                    })}
                    
                </div>
            </div>
      ) : (
        <>
            <Spinner size={SpinnerSize.large}>Vennligst vent...</Spinner>
        </>
      )
    }
  }

  const mapStateToProps = (state) => {
    return {
      scheduleElements: state.scheduleElements,
      ukeplanelementsstudent: state.ukeplanelements.ukeplanelementsstudent
    };
  };

  export default connect(mapStateToProps,{getScheduleElements,getUkeplanElementsStudent})(UkeplanPrintView);